import Drum from './Drum';
import './App.css';



function App() {
  return (
    <div className="App">
      <Drum/>
    </div>
  );
}

export default App;
